module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_17.6f48b754.jpg";